import { getAuthUrl } from 'utils/url-generator';
import { CommunityNavigation, LoggedInUser } from '@atlassian/learning-components';
import { ENVIRONMENT, getEnvironmentAsEnum } from 'utils/environment';
import {
  CommunityAnalyticsClient,
  getCommunityLogoutUrl,
  eventType,
  getCommunityLoginUrl,
} from '@atlassian/community-library';
import {
  accountSwitcherIsActive,
  communityAppUpdatesIsActive,
  newNavigationIsActive,
} from '../../services/statsig/featureGates';
import { getAppByRoute } from '../../utils/route-utils';

interface Props {
  isLoggedIn: boolean;
  loggedInUser: LoggedInUser;
}

export const TopNavigationContents = ({ isLoggedIn, loggedInUser }: Props) => {
  // using globalThis.location causes a hydration error since the location will be a
  // tesseract server when it renders on the server instead of community-ui.atlassian.com
  const pathname = globalThis.location.pathname;

  const currentPage = encodeURIComponent(`${process.env.HOME_BASE_URL}${pathname.replace('index.html', '')}`);
  const currentEnv = getEnvironmentAsEnum();
  const loginHref = getCommunityLoginUrl(
    {
      redirectUrl: currentPage,
      experience: 'entry-auth',
      email: loggedInUser.email || '',
    },
    currentEnv,
  );
  const logoutHref = getCommunityLogoutUrl(
    {
      redirectUrl: currentPage,
      experience: 'entry-auth',
      email: loggedInUser.email || '',
    },
    currentEnv,
  );
  const signupHref = getSignupHref(currentPage, loggedInUser.email || '');
  const switchHref = getSwitchHref(currentPage, currentEnv);

  return (
    <CommunityNavigation
      currentApp={getAppByRoute(pathname)}
      isLoggedIn={isLoggedIn}
      user={loggedInUser}
      loginHref={loginHref}
      logoutHref={logoutHref}
      signupHref={signupHref}
      switchHref={switchHref}
      onAnalyticsSendEvent={(type, payload) =>
        CommunityAnalyticsClient.sendEvent(type as unknown as eventType, payload)
      }
      email={loggedInUser.email}
      showNewMenu={newNavigationIsActive()}
      showAppUpdates={communityAppUpdatesIsActive()}
    />
  );
};

const getSignupHref = (currentPage: string, email: string) => {
  return getAuthUrl('signup', {
    redirectUrl: currentPage,
    experience: 'entry-auth',
    email,
  });
};

const getSwitchHref = (currentPage: string, env: ENVIRONMENT) => {
  return accountSwitcherIsActive()
    ? getCommunityLoginUrl(
        {
          redirectUrl: currentPage,
          experience: 'entry-auth',
          prompt: 'select_account',
        },
        env,
      )
    : '';
};
